import { Person } from '@kavrillon/tree-core';

interface IProps {
  person: Person;
}

export const PersonDeathLabel = ({ person }: IProps) => (
  <>{person.gender === 'H' ? 'Décédé' : 'Décédée'}</>
);
